
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import httpClient from "@/store/httpClient";

@Component
export default class CompareMaterialDialog extends Vue {
	@Prop()
	private open!: boolean;
	@Prop()
	private materials!: [];
	@Prop()
	private baseMaterial!: any;
	@Prop()
	private werkstoffName!: string;
	private loading: boolean = false;
	private valid: boolean = true;
	private compareMaterialName: string = "";
	private selectedCompareMaterialId: number = 0;
	private differencesText: string = "";
	private compareMaterialRule = [
		(v: number) => !!v || "Vergleichsmaterial muss ausgewählt werden",
		(v: number) => !v || v > 0 || "Vergleichsmaterial muss ausgewählt werden",
	];

	private mounted() {
		(this.$refs.form as any).validate();
	}

	private get baseMaterialName() {
		return this.baseMaterial["bezeichnung"];
	}

	private selectCompareMaterial() {
		let material = this.materials.filter(
			(m: any) => m.id === this.selectedCompareMaterialId
		)[0];
		this.compareMaterialName = material["name"];
		this.compareMaterials();
	}

	private copyMaterial() {
		let data = {
			baseMaterialId: this.baseMaterial.rohmaterialId,
			baseWerkstoffName: this.werkstoffName,
			materialBeschreibung: "",
			thickness: 0,
			compareMaterialId: this.selectedCompareMaterialId,
		};
		this.differencesText = "";
		this.selectedCompareMaterialId = 0;
		this.$emit("copy", data);
	}

	private async compareMaterials() {
		try {
			this.loading = true;
			this.differencesText = "";
			let data = {
				baseMaterialId: this.baseMaterial.rohmaterialId,
				baseWerkstoffName: this.werkstoffName,
				materialBeschreibung: "",
				thickness: 0,
				compareMaterialId: this.selectedCompareMaterialId,
			};
			const response = await httpClient().post(
				`Material/GetDifferencesBetweenMaterials`,
				data
			);
			// Display differences
			this.differencesText = response.data.replace(/\n/g, "<br>");
			this.$store.commit("setSnackbarText", "Material verglichen.");
		} catch (err) {
			this.$store.commit("setSnackbarErrorText", "Material konnte nicht verglichen werden.");
		} finally {
			this.loading = false;
		}
	}

	private close() {
		this.differencesText = "";
		this.selectedCompareMaterialId = 0;
		this.$emit("close");
	}
}
